import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-md-10 col-lg-8 col-xl-9 col-xxl-8 col-xxxl-6" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white authentication-card" }
const _hoisted_4 = { class: "card-body letter-spacing" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[16] || (_cache[16] = _createElementVNode("h4", { class: "text-black fw-bold mb-0 text-center" }, " Créez votre compte ", -1)),
          _createElementVNode("form", {
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($setup.handleSubmit && $setup.handleSubmit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nom Complet (*)", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.name) = $event)),
                class: "form-control shadow-none rounded-0 text-black"
              }, null, 512), [
                [_vModelText, $setup.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Adresse e-mail (*) ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "email",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.email) = $event)),
                class: "form-control shadow-none rounded-0 text-black"
              }, null, 512), [
                [_vModelText, $setup.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Numéro de téléphone (*) ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                pattern: "[0-9]*",
                inputmode: "numeric",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.phone) = $event)),
                class: "form-control shadow-none rounded-0 text-black"
              }, null, 512), [
                [_vModelText, $setup.phone]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " CIN (*) ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.cin) = $event)),
                class: "form-control shadow-none rounded-0 text-black"
              }, null, 512), [
                [_vModelText, $setup.cin]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Ville ", -1)),
              _createVNode(_component_v_select, {
                class: "custom-select-height",
                options: $setup.citiesList,
                label: "name",
                modelValue: $setup.city,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.city) = $event)),
                placeholder: "Ville *"
              }, null, 8, ["options", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Message ", -1)),
              _withDirectives(_createElementVNode("textarea", {
                rows: "3",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.message) = $event)),
                class: "form-control shadow-none rounded-0 text-black"
              }, null, 512), [
                [_vModelText, $setup.message]
              ])
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("button", {
              class: "default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 bg-success d-block w-100",
              type: "submit"
            }, " S'inscrire ", -1)),
            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "d-block text-muted text-center mt-15 mt-md-30 mb-12 mb-md-20 fs-md-15 fs-lg-16" }, " Vous avez déjà un compte ? ", -1)),
            _createVNode(_component_router_link, {
              to: "/login",
              class: "default-btn with-border transition fw-medium rounded-1 fs-md-15 fs-lg-16 d-block w-100 text-decoration-none text-center"
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [
                _createTextVNode(" Se connecter ", -1)
              ])),
              _: 1,
              __: [13]
            })
          ], 32)
        ])
      ])
    ])
  ]))
}